export const generateCurrentPackageServices = (services, packageServices) => {
  return [...services].map((srvc) => {
    let newSrvs = { ...srvc }
    let packaegSrvc = packageServices.find((ps) => {
      return ps.id === srvc.id
    })
    if (packaegSrvc) {
      newSrvs.checked = true
    }
    return newSrvs
  })
}
